import styled from 'styled-components'
import Image from '../Image'

export default function HeroImageOnly( { image } ) {
  return (
    <StyledHeroImageOnly>
      <Image
        src={ image.url }
        alt={ image.alt }
        dateModified={ image.dateModified }
        layout="fill"
        objectFit="cover"
      />
    </StyledHeroImageOnly>
  )
}

const StyledHeroImageOnly = styled.div`
  position: relative;
  height: min( 65vw, calc( 100vh - 72px ) );
`
